/* eslint-disable camelcase */
import React, {ReactElement, useState} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Card,
  CardContent,
  TableCell,
  TableRow,
  makeStyles
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import HelperUtils, {getStatementStatus} from '@shared/utils/HelperUtils';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import {
  APP,
  // DEFAULT_BLACK_COLOR,
  DEFAULT_WHITE_COLOR,
  FONT_SECONDARY_COLOR
} from 'src/style/variable';

// import PaymentsCard from 'src/modules/payments/paymentsCard/PaymentsCard';
import {invoiceDetails} from '@shared/services/DueInvoiceServices';
import {
  AppPermissions,
  StatementNoticeType,
  StatementStatus
} from '@shared/constants/Mapping';
import './CurrentStatementsCard.scss';
import MinGridTable, {
  ColumnDef
} from '@components/system/MinGridTable/MinGridTable';
import {CommunicationService} from 'src/service/CommunicationService';
import {Subscription} from 'rxjs';
import TertiaryButton from '@components/system/ButtonField/TertiaryButton';
import AddStatementDialog from './AddStatementDialog/AddStatementDialog';
import {State} from '@shared/store/reducers/Index';
import {Permission} from '@shared/services/PermissionService';

const currentStatementCardStyles = makeStyles(theme => ({
  paymentDetailsContentView: {
    overflowY: 'auto',
    maxHeight: '20rem',
    marginTop: '0.5rem'
  },
  paymentsSectionView: {
    flex: 1,
    display: 'flex',
    // paddingTop: '1rem',
    fontSize: '1rem',
    padding: '0.5rem'
  },
  newVisitStyle: {
    '&:not(:first-child)': {
      borderTop: '1.5px solid gray'
    }
  },
  flexView: {
    flex: 1,
    display: 'flex',
    fontSize: '1rem',
    gap: '1rem'
  },
  leftView: {
    display: 'flex',
    // color: DEFAULT_BLACK_COLOR,
    // marginRight: '2em',
    width: '25%',
    color: '#343434'
  },
  rightView: {
    display: 'flex',
    alignItems: 'flexStart',
    justifyContent: 'flexEnd',
    alignContent: 'flexEnd',
    // color: DEFAULT_BLACK_COLOR,
    textAlign: 'end',
    color: '#343434',
    fontWeight: 600
  },
  middleView: {
    display: 'flex',
    flex: 1,
    // color: DEFAULT_BLACK_COLOR
    color: '#8C8C8C'
    // marginRight: '2em'
  },
  infoText: {
    color: FONT_SECONDARY_COLOR,
    fontSize: '1rem',
    lineHeight: '1rem',
    padding: '1rem'
  },
  applyOddColor: {
    backgroundColor: 'rgb(0,0,0,0.05)'
  },
  applyEvenColor: {
    backgroundColor: DEFAULT_WHITE_COLOR
  },
  cardRoot: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '13px'
    }
  },
  cardContent: {
    [theme.breakpoints.down('sm')]: {
      padding: '0.5rem'
    }
  },
  headersPadding: {
    paddingTop: 0,
    paddingBottom: 0
  },
  headerText: {
    color: APP.STATUS.DEFAULT,
    fontSize: '1rem'
  },
  divider: {
    marginTop: '0.5rem'
  },
  setPadding: {
    padding: '0.8rem'
    // border: '1px solid #DDDDDD'
  },
  margin: {
    marginTop: '1rem'
  },
  contentSpace: {
    display: 'flex',
    fontSize: '1.3rem',
    paddingBlock: '1rem',
    fontWeight: 600,
    justifyContent: 'space-between'
  },
  cardHeader: {
    '& .MuiCardContent-root': {
      padding: '0'
    }
  },
  amountWrapper: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  loaderStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rightAlignHeader: {
    textAlign: 'right'
  }
}));

interface CurrentStatementsCardProps {
  invoiceId: number | string;
  clinicId: number | string;
  patientId: number | string;
  guarantorId: number | string;
  patient: any;
  refreshStatementsTab: () => void;
}

const CurrentStatementsCard = (
  props: CurrentStatementsCardProps
): ReactElement => {
  const {
    clinicId,
    guarantorId,
    patientId,
    patient,
    refreshStatementsTab
  } = props;

  const {t} = useTranslation();

  const {enqueueSnackbar} = useSnackbar();

  const classes = currentStatementCardStyles();

  const {groupId, userGroups} = useSelector((state: any) => state.auth);
  const clinicsList = useSelector((state: State) => state.clinics.list) ?? [];

  let selectedGroup: any;
  if (userGroups && Array.isArray(userGroups) && userGroups.length > 0) {
    selectedGroup = userGroups.find(item => item.id == groupId);
  }

  const consolidatedBillingGroupEnable: boolean = useSelector(
    (state: any) => state.clinics.consolidatedBillingGroupEnable || null
  );
  const [invoiceLinesData, setInvoiceLinesData]: any = useState({});
  const [isLoadingCurrentStatements, setIsLoadingCurrentStatements] = useState(
    true
  );
  const subscription = React.useRef<Subscription>();
  const [showAddPatientDialog, setShowAddPatientDialog] = useState(false);

  const openAddPatientDialog = () => {
    setShowAddPatientDialog(true);
  };

  const closeAddStatementDialog = () => {
    setShowAddPatientDialog(false);
  };

  const getPatientCurrentStatements = async (): Promise<void> => {
    setIsLoadingCurrentStatements(true);
    invoiceDetails(
      groupId,
      clinicId,
      patientId,
      consolidatedBillingGroupEnable === true
    )
      .then(invoiceDetailsResponse => {
        if (invoiceDetailsResponse?.data) {
          setInvoiceLinesData(invoiceDetailsResponse?.data);
        }
      })
      .catch(error => {
        enqueueSnackbar(error && error.message, SnackBarConfig('e'));
      })
      .finally(() => {
        setIsLoadingCurrentStatements(false);
      });
  };
  React.useEffect(() => {
    if (patientId != null) {
      getPatientCurrentStatements();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicId, guarantorId, patientId]);

  React.useEffect(() => {
    // if there is an update available and no state passed
    subscription.current = CommunicationService.getEvent().subscribe(data => {
      if (
        data.action === 'GUARANTOR_PAYMENT_COMPLETED' ||
        data.action === 'GUARANTOR_STATEMENT_SETTLED'
      ) {
        getPatientCurrentStatements();
      }
    });
    return () => {
      subscription.current?.unsubscribe();
    };
    // eslint-disable-next-line
  }, []);

  const renderLocationLine = (
    locationName: string,
    dueNoticeType: string,
    guarantorDue: {
      original_due_amount: number;
      due_amount: number;
      paid_due_amount: number;
      is_settled: boolean;
    }
  ): JSX.Element => {
    return (
      <div
        key={locationName}
        // style={{borderBottom: '1px solid #DDDDDD'}}
        // className={[
        //   classes.paymentsSectionView,
        //   classes.setPadding,
        //   // classes.applyEvenColor,
        //   classes.newVisitStyle
        // ].join(' ')}
      >
        <div className={classes.flexView} style={{fontWeight: 'bold'}}>
          <div>{locationName}</div>
          <div>
            {(dueNoticeType === StatementNoticeType.FN.key ||
              dueNoticeType === StatementNoticeType.PD.key) && (
              <span
                className={[
                  'due-notice-type-chip',
                  dueNoticeType === StatementNoticeType.FN.key
                    ? 'due-notice-type-fn-chip'
                    : '',
                  dueNoticeType === StatementNoticeType.PD.key
                    ? 'due-notice-type-pd-chip'
                    : ''
                ].join(' ')}>
                {dueNoticeType === StatementNoticeType.FN.key
                  ? StatementNoticeType.FN.label
                  : StatementNoticeType.PD.label}
              </span>
            )}
            {getStatementStatus(guarantorDue) && (
              <span
                className={[
                  'due-notice-type-chip',
                  guarantorDue?.is_settled ||
                  (guarantorDue?.original_due_amount > 0 &&
                    guarantorDue?.due_amount === 0)
                    ? 'due-status-paid'
                    : 'due-status-unpaid'
                ].join(' ')}>
                {getStatementStatus(guarantorDue)}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const currentStatementColDefs: ColumnDef<any>[] = [
    {
      label: t('PATIENT_DETAILS_CARD.HEADERS.DATE'),
      render(obj) {
        return HelperUtils.formatDisplayDate(obj.service_date);
      }
    },
    {
      label: t('PATIENT_DETAILS_CARD.HEADERS.DESCRIPTION'),
      render(obj) {
        return obj.description;
      }
    },
    {
      label: t('PATIENT_DETAILS_CARD.HEADERS.AMOUNT'),
      render(obj) {
        if (obj.amount === null) return '';
        return (
          <CurrencyFormatter
            value={obj.amount}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            ignoreRound={true}
            useSign={true}
          />
        );
      },
      colValueCellProps: {
        className: 'table-amount-col'
      },
      colHeaderCellProps: {
        className: classes.rightAlignHeader
      }
    }
  ];

  const renderBalanceDueNew = (): ReactElement => {
    return (
      <div className="balance-header-info">
        <div className="balance-title">{t('PATIENT_DETAILS_CARD.TOTAL')}</div>
        <div className="balance">
          <CurrencyFormatter
            value={invoiceLinesData?.balance_amount ?? 0}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            ignoreRound={true}
            useSign={true}
          />
        </div>
      </div>
    );
  };

  const rows: any = [];
  const clinicIdKeys = Object.keys(
    invoiceLinesData?.grouped_invoice_data ?? {}
  );
  clinicIdKeys.forEach((clinicIdKey: string) => {
    const invoiceData = invoiceLinesData?.grouped_invoice_data?.[clinicIdKey];
    const orgDetails = invoiceData?.clinic_details;
    const due = invoiceData?.due;
    rows.push({
      render: () => (
        <TableRow>
          <TableCell
            colSpan={3}
            style={
              {
                // borderBlock: '1px solid black'
              }
            }>
            {renderLocationLine(orgDetails?.name, due?.due_notice_type, {
              original_due_amount: due?.original_due_amount,
              due_amount: due?.current_due_amount,
              paid_due_amount: due?.paid_due_amount,
              is_settled: due?.is_settled
            })}
          </TableCell>
        </TableRow>
      )
    });
    if (Array.isArray(invoiceData?.invoice?.lines)) {
      invoiceData.invoice.lines.forEach((ele: any, index: number) => {
        rows.push(ele);
      });
    }
  });

  let addStatementClinicIdList = clinicsList.map((c: any) => c?.id);
  if (
    !selectedGroup?.patients_shared ||
    !selectedGroup?.consolidated_group_billing
  ) {
    addStatementClinicIdList = addStatementClinicIdList.filter(
      (cId: any) => cId == clinicId
    );
  }
  addStatementClinicIdList = addStatementClinicIdList.filter((cId: any) => {
    const invoiceData = invoiceLinesData?.grouped_invoice_data?.[cId];
    const due = invoiceData?.due;
    const clinicStatementStatus = getStatementStatus({
      original_due_amount: due?.original_due_amount,
      due_amount: due?.current_due_amount,
      paid_due_amount: due?.paid_due_amount,
      is_settled: due?.is_settled
    });
    if (
      clinicStatementStatus === null ||
      clinicStatementStatus === StatementStatus.UN_PAID
    )
      return true;
    return false;
  });

  const {userPermissions} = useSelector((state: State) => state.auth);
  const hasCreateStatementPermission = Permission.hasStatementPermissions(
    userPermissions,
    AppPermissions.STATEMENT.CREATE,
    groupId
  );

  return (
    <div className="current-statement-card-wrapper">
      <div className={classes.contentSpace}>
        <span>{t('DUE_INVOICES.PATIENT_DRAWER.CURRENT_STATEMENT')}</span>
        {hasCreateStatementPermission &&
          !isLoadingCurrentStatements &&
          addStatementClinicIdList.length > 0 && (
            <TertiaryButton onClick={openAddPatientDialog}>
              {t('COMMON.ADD')}
            </TertiaryButton>
          )}
      </div>
      <Card className={classes.cardHeader}>
        <CardContent>
          <MinGridTable
            isLoading={isLoadingCurrentStatements}
            colDefs={currentStatementColDefs}
            rows={rows}
            noDataText={t('DUE_INVOICES.NO_INVOICE_DATA')}
          />
          {renderBalanceDueNew()}
        </CardContent>
      </Card>
      {showAddPatientDialog && (
        <AddStatementDialog
          open={showAddPatientDialog}
          onClose={res => {
            closeAddStatementDialog();
            if (res === 'confirm') {
              refreshStatementsTab();
            }
          }}
          groupedInvoiceLines={invoiceLinesData?.grouped_invoice_data}
          patient={patient}
          defaultClinicId={
            addStatementClinicIdList.includes(clinicId)
              ? (clinicId as number)
              : addStatementClinicIdList?.[0]
          }
          clinicIdsWithUnpaidStatement={addStatementClinicIdList}
        />
      )}
    </div>
  );
};

export default CurrentStatementsCard;
